import React, { useState } from "react";
import { Box, Typography, Link, Modal } from "@mui/material";
import { ITemplate } from "../ITemplateDetail";
import { Button } from "../../../components/Button";
import AnalyticsTable from "./AnalyticsTable";
import * as Assets from "../../../components/Icon/assets";

export const DynamicLinks = ({ templates }: { templates: ITemplate }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const copyHandler = () => {
    navigator.clipboard.writeText(templates.shares[0].dynamicLink);
  };
  const modalHandler = () => {
    setOpenModal(!openModal);
  };
  return (
    <Box
      height={60}
      sx={{
        display: "flex",
        alignItems: "center",
        m: "10px",
        mt: "-15px",
        mb: "-20px",
      }}
    >
      <Box sx={{ width: "24px", mr: "8px" }} />
      <Box width={"30%"}>
        <Typography fontWeight={500}>Dynamic Link</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          alignItems: "center",
          ".MuiButton-root": {
            color: "blue !important",
          },
        }}
      >
        <Typography minWidth={"20%"}>
          {templates.shares ? (
            <Link href={templates.shares[0].dynamicLink}>
              {templates.shares[0].dynamicLink}
            </Link>
          ) : (
            ""
          )}
        </Typography>
        {templates.shares && templates.shares[0].dynamicLink ? (
          <>
            <Button label="Copy" type="text" onClick={copyHandler} />
            <Button label="Analytics" type="text" onClick={modalHandler} />
            <img
              src={Assets.Analytics}
              alt="time"
              style={{ width: 16, height: 16 }}
            />
            <Modal open={openModal} onClose={modalHandler}>
              <Box
                sx={{
                  backgroundColor: "#FFFFFF",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  width: "800px",
                  minHeight: "280px",
                  transform: "translate(-50%, -50%)",
                  padding: "32px",
                }}
              >
                <Typography sx={{ fontWeight: 700, marginBottom: "16px" }}>
                  Dynamic Link Analytics
                </Typography>
                <AnalyticsTable
                  dynamicLinks={templates.shares[0].dynamicLink}
                />
              </Box>
            </Modal>
          </>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
};
